import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const BookletMaterialReadSlice = createSlice({
  name: "BookletMaterialReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    bookletMaterialRead: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successBookletMaterialRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureBookletMaterialRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearBookletMaterialRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  bookletMaterialRead,
  failureBookletMaterialRead,
  successBookletMaterialRead,
  clearBookletMaterialRead,
} = BookletMaterialReadSlice.actions;

export default BookletMaterialReadSlice.reducer;
